import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import useUsers from '../api/useUsers';
import { EFeatureFlag } from '../constants/enums';
import { pageFeatureFlagMap } from '../design-system/AcSidebar/constants';
import { ESideBarChipType } from '../design-system/AcSidebar/types';

export const usePageTypeByFeatureFlag = (pageName: string) => {
  const { publisherId } = useParams();
  const { fetchFeatureFlags } = useUsers({ publisherId });
  const { data, isLoading, error } = fetchFeatureFlags;
  const [pageType, setPageType] = useState<ESideBarChipType | null>(null);
  const featureFlagKey = pageFeatureFlagMap[pageName] as EFeatureFlag;
  const isPageDisabled =
    pageType === ESideBarChipType.LOCKED ||
    pageType === ESideBarChipType.COMING_SOON;

  useEffect(() => {
    if (isLoading || error || !featureFlagKey) return;

    const featureFlagData = data?.featureFlags[featureFlagKey];

    if (
      featureFlagData &&
      typeof featureFlagData === 'object' &&
      'treatment' in featureFlagData
    ) {
      setPageType(featureFlagData.treatment);
    } else {
      setPageType(null);
    }
  }, [data, isLoading, error, featureFlagKey]);

  return { pageType, isPageDisabled };
};
